import { styled } from '@mui/material/styles';
import { Card, Typography, Tooltip } from '@mui/material';
import PropTypes from 'prop-types';

// utils
//
import Iconify from '../../../components/Iconify';

// ----------------------------------------------------------------------

const RootStyle = styled(Card)(({ theme }) => ({
  boxShadow: 'none',
  textAlign: 'center',
  padding: theme.spacing(5, 0),
  color: theme.palette.grey[600],
  backgroundColor: '#edf6ff'
}));

const IconWrapperStyle = styled('div')(({ theme }) => ({
  margin: 'auto',
  display: 'flex',
  borderRadius: '50%',
  alignItems: 'center',
  border: '1px solid',
  borderColor: theme.palette.grey[600],
  width: theme.spacing(8),
  height: theme.spacing(8),
  justifyContent: 'center',
  marginBottom: theme.spacing(3),
  color: theme.palette.grey[600]
}));

// ----------------------------------------------------------------------

export default function StakingApy(props) {
  const { apy } = props;
  return (
    <RootStyle
      sx={{
        boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px',
        borderRadius: '3em',
        zIndex: 1
      }}
    >
      <IconWrapperStyle>
        <Iconify icon="mdi:lock-outline" width={30} height={30} />
      </IconWrapperStyle>
      <Typography variant="h3">{apy}%</Typography>
      <Tooltip title="APR is calculated as (% of eth gained per lp token) / (total days since launched) * (365 days)">
        <Typography variant="subtitle2" sx={{ opacity: 0.72, zIndex: 7 }}>
          LP Staking APR*
        </Typography>
      </Tooltip>
    </RootStyle>
  );
}
StakingApy.propTypes = {
  apy: PropTypes.string.isRequired
};
